import { createApiAction } from 'services/api';
import {
  StartAction,
  SuccessAction,
  FailureAction,
} from 'services/api/redux/types';
import {
  createAddSearch,
  createDeleteSearch,
  createFetchSearch,
  createUpdateSearch,
} from 'services/search';

export enum ProjectsActionTypes {
  FETCH_PROJECTS_START = 'projects/fetch_projects_start',
  FETCH_PROJECTS_SUCCESS = 'projects/fetch_projects_success',
  FETCH_PROJECTS_FAILURE = 'projects/fetch_projects_failure',
}

const fetchProjectsActionStart = (): StartAction => ({
  type: ProjectsActionTypes.FETCH_PROJECTS_START,
  payload: null,
});

const fetchProjectsActionSuccess = (payload: any): SuccessAction => {
  return {
    type: ProjectsActionTypes.FETCH_PROJECTS_SUCCESS,
    payload,
  };
};

const fetchProjectsActionFailure = (error: string): FailureAction => ({
  type: ProjectsActionTypes.FETCH_PROJECTS_FAILURE,
  payload: { error },
});

export const fetchProjects = () =>
  createApiAction(
    {
      path: '/v1/projects',
      method: 'GET',
    },
    fetchProjectsActionStart,
    fetchProjectsActionSuccess,
    fetchProjectsActionFailure
  );

// SEARCH ACTION CREATORS

export const fetchSearch = createFetchSearch('projects');
export const addSearch = createAddSearch('projects');
export const updateSearch = createUpdateSearch('projects');
export const deleteSearch = createDeleteSearch('projects');
